import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { Interaction } from '@dbk/ui-charts';

import { XSmall } from '../../common/text';
import { Currency } from '../../common/number';
import SimpleDate from '../../common/date';

import styles from './interactions.styles';

const VERTICAL_OFFSET = 10;

function Interactions({ data, currency, selectedValue, onChange, messages, hasCustomInteractions }) {
  if (selectedValue !== null && selectedValue != undefined && data[selectedValue] && data[selectedValue].value == '') {
    selectedValue = null
  }
  return (
    <Interaction
      xAxis="x"
      selectedValue={selectedValue}
      onChange={onChange}
    >
      {!hasCustomInteractions && <Interaction.XGroup>
        <Interaction.VerticalLine
          top={VERTICAL_OFFSET}
          wrapper={Interaction.HideLink}
        />
        <Interaction.DataPointView
          top={VERTICAL_OFFSET}
          view={item => (
            <View
              style={styles.flag}
              testID="line-chart-popup"
            >
              <View style={styles.wrapper}>
              {
                !!item.tooltipText &&
                <View style={styles.tooltipWrapper}>
                  <XSmall style={{color:'white'}}>{item.tooltipText}</XSmall>
                </View>
              }


              { item.subTitleText== null && !item.tooltipText &&
                <XSmall style={{color:'white', margin: 4}}>{item.titleText}</XSmall>
              }


              { item.subTitleText!= null && !item.tooltipText &&
                <XSmall style={{color:'white', margin: 4}}> <SimpleDate renderProps={{
                  size: 'xsmall'
                }}
                value={item.subTitleText}/> </XSmall>
              }


               {
                !item.tooltipText &&
                <Currency
                  value={item.value}
                />
              }
              </View>
            </View>
          )}
        />

      </Interaction.XGroup>}
    </Interaction>
  );
}

Interactions.propTypes = {
  data: PropTypes.array.isRequired,
  currency: PropTypes.string,
  selectedValue: Interaction.propTypes.selectedValue,
  onChange: PropTypes.func,
};

export default Interactions;
